const {
  createBrowserHistory,
  createHashHistory,
  createMemoryHistory,
  createLocation,
  locationsAreEqual,
  createPath,
  parsePath,
} = require("history");

/**
 * Patch for avoiding that single-spa posts an event when routes are changed to the
 * qmfe component that caused the event.
 */
function patchedCreateBrowserHistory(options) {
  const browserHistory = createBrowserHistory(options);
  const ORIGINAL_BROWSER_HISTORY_LISTEN = browserHistory.listen;
  browserHistory.listen = (listener) => {
    let lastLocation;
    const wrappedListener = (location, action) => {
      if (
        !lastLocation ||
        lastLocation.pathname !== location.pathname ||
        lastLocation.search !== location.search ||
        lastLocation.hash !== location.hash ||
        action !== "POP"
      ) {
        lastLocation = location;
        listener(location, action);
      } else {
        lastLocation = location;
      }
    };
    return ORIGINAL_BROWSER_HISTORY_LISTEN.call(
      browserHistory,
      wrappedListener
    );
  };
  return browserHistory;
}

module.exports = {
  createBrowserHistory: patchedCreateBrowserHistory,
  createHashHistory,
  createMemoryHistory,
  createLocation,
  locationsAreEqual,
  createPath,
  parsePath,
};
